/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlActiveEntityFindingsAggResult } from './ControlActiveEntityFindingsAggResult';
import {
    ControlActiveEntityFindingsAggResultFromJSON,
    ControlActiveEntityFindingsAggResultFromJSONTyped,
    ControlActiveEntityFindingsAggResultToJSON,
} from './ControlActiveEntityFindingsAggResult';

/**
 * 
 * @export
 * @interface ControlPaginatedActiveEntityFindingsAggResponse
 */
export interface ControlPaginatedActiveEntityFindingsAggResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedActiveEntityFindingsAggResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedActiveEntityFindingsAggResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedActiveEntityFindingsAggResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlActiveEntityFindingsAggResult>}
     * @memberof ControlPaginatedActiveEntityFindingsAggResponse
     */
    results?: Array<ControlActiveEntityFindingsAggResult>;
}

/**
 * Check if a given object implements the ControlPaginatedActiveEntityFindingsAggResponse interface.
 */
export function instanceOfControlPaginatedActiveEntityFindingsAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedActiveEntityFindingsAggResponseFromJSON(json: any): ControlPaginatedActiveEntityFindingsAggResponse {
    return ControlPaginatedActiveEntityFindingsAggResponseFromJSONTyped(json, false);
}

export function ControlPaginatedActiveEntityFindingsAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedActiveEntityFindingsAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlActiveEntityFindingsAggResultFromJSON)),
    };
}

export function ControlPaginatedActiveEntityFindingsAggResponseToJSON(value?: ControlPaginatedActiveEntityFindingsAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlActiveEntityFindingsAggResultToJSON)),
    };
}

